/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Status_Tournament_SyncInputs */



/**
* | output |
* | --- |
* | "VEKN tournament sync" |
*
* @param {Admin_Status_Tournament_SyncInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_status_tournament_sync = /** @type {((inputs?: Admin_Status_Tournament_SyncInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Status_Tournament_SyncInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation des tournois VEKN")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronización de torneos VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sincronização de torneios VEKN")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione tornei VEKN")
	return /** @type {LocalizedString} */ ("VEKN tournament sync")
});